import { route } from '@/utils/build'
const component = path => resolve => require(['@/pages/payment/views/' + path], resolve)

/**
 * 注册积分商城相关路由
 */
export default [
  // 训练营首页
  route('/trainCamp', 'trainCamp', component('trainCamp/index'), { keepAlive: true }),
  route('/trainActivity', 'trainActivity', component('trainCamp/index'), { keepAlive: true }),
  route('/trainVip', 'trainVip', component('trainCamp/index'), { keepAlive: true }),
  route('/trainJoin', 'trainJoin', component('trainCamp/trainJoin/index')),
  route('/joinSuccess', 'joinSuccess', component('trainCamp/joinSuccess/index'))
]
